module.exports = __webpack_public_path__ + "media/images/logo_horiz-a5641148d433d3d5a9e9ca8925177292ebc2c370044f09a760a83a06b9d5cb6e.png";